import { ListItemText as MuiListItemText, type ListItemTextProps as MuiListItemTextProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiListItemTextProps, 'slots'>>;

export function ListItemText(props: Props) {
  return <MuiListItemText {...props} />;
}

export type { Props as ListItemTextProps };
